.avatar-time-container {
    text-align: center;
}

/* This puts the date on two lines */
.date-container {
    width: 80px;
}
